import { WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export default function OfflineScreen() {
  const [checking, setChecking] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <div className="flex items-center justify-center py-16 px-4">
      <div className="w-full max-w-xl rounded-2xl border border-[#1C2A44] bg-[hsl(215,15%,14%)] p-6 text-center">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#00FF8C20]">
          <WifiOff className="h-6 w-6 text-[#00FF8C]" />
        </div>
        <h2 className="text-xl font-bold text-white mb-2">You’re offline</h2>
        <p className="text-sm text-white/80 mb-6">
          Your internet connection appears to be disconnected. Please reconnect to continue.
        </p>
        {failed ? (
          <p className="text-xs text-white/70 mb-4">Still offline. Please check your connection.</p>
        ) : null}
        <div className="flex items-center justify-center">
          <Button
            className="bg-[#4C73FF] text-white hover:brightness-110"
            disabled={checking}
            onClick={async () => {
              setChecking(true);
              setFailed(false);

              const controller = new AbortController();
              const timeout = window.setTimeout(() => controller.abort(), 2000);

              try {
                // Fast same-origin network probe (no-store forces a real network check).
                await fetch(`/robots.txt?ping=${Date.now()}`, {
                  cache: "no-store",
                  signal: controller.signal,
                });
                window.clearTimeout(timeout);
                window.location.reload();
              } catch {
                window.clearTimeout(timeout);
                setFailed(true);
                setChecking(false);
              }
            }}
          >
            {checking ? "Checking..." : "Retry"}
          </Button>
        </div>
      </div>
    </div>
  );
}
